// ©2024 Austin App House. All rights reserved.
import React, { createRef } from 'react';
import {
  MDBBtn, MDBCol, MDBInput, MDBRow,
} from 'mdbreact';
import Select from 'react-select';
import { localCurrencySettings, rolloverInfoMessage } from '../../../../utils/constans';
import { dark as customSelectStyle } from '../../../../utils/customSelectStyle';
import CustomValueContainer from '../../../layout/customSelectElements/ValueContainerForMultiSelect';
import CustomMultiValueLabel from '../../../layout/customSelectElements/MultiValueLabel';
import ExplanationInputModal from '../../ExplenationInputModal';
import PortalContainer from '../../Portal';
import Notification from '../../../notification';
import isDeviceType from '../../../../utils/isDeviceType';
import getQtyByPayType from '../../../../utils/getQtyByPayType';
import EstimatedTimeOverageLabel from '../../../layout/EstimatedTimeOverageLabel';
import workOrderStatusControl from '../../../../utils/workOrderStatusControl';
import { connect } from "react-redux";
import { revertWorkOrderTo } from "../../../../storage/actions/workOrdersActions";

class ApproveWorkOrder extends React.Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    quantity: 0,
    finalEstimateTotal: 0,
    finalPayAdjustment: 0,
    approvedBasePotentialPay: 0,
    adjustmentReason: '',
    communication: true,
    work: true,
    deliverables: true,
    disabled: false,
    selectedExpenses: [],
    expenses: [],
    rejectedExpensesReasons: {},
    newRejection: '',
  };

  componentDidMount() {
    this.getStateUpdateByProps();
  }

  componentDidUpdate(prevProps) {
    const prevCheckInCount = prevProps.currentWorkOrder.checkInOutDetails?.length ?? 0;
    const nextCheckInCount = this.props.currentWorkOrder.checkInOutDetails?.length ?? 0;

    if (
      prevProps.currentWorkOrder._id !== this.props.currentWorkOrder._id
      || prevProps.currentWorkOrder.status !== this.props.currentWorkOrder.status
      || prevCheckInCount !== nextCheckInCount
    ) this.getStateUpdateByProps();
  }

  controlBoolValue = value => {
    if (typeof value === 'boolean') return value;
    return true;
  }

  getStateUpdateByProps = () => {
    const { currentWorkOrder, auth } = this.props;
    if (!currentWorkOrder?._id) return undefined;

    const expenseItems = currentWorkOrder.expenses || [];
    const approvedExpenseIds = currentWorkOrder.approvedExpenses || [];
    const expenses = expenseItems.map(item => ({
      label: `${new Date(item.date)
        .toLocaleDateString('en-US', { timeZone: 'UTC' })
        } ${item.amount.toLocaleString('en-US', localCurrencySettings)} ${item.description}`,
      amount: item.amount,
      value: item._id,
      reason: item.rejection_reason,
    }));
    const rejectedExpensesReasons = {};
    expenses
      .filter(item => !approvedExpenseIds.includes(item.value))
      .forEach(item => {
        rejectedExpensesReasons[item.label] = item.reason;
      });
    return this.setState({
      disabled: currentWorkOrder.status !== 'completed'
        || auth.user.userType === 'contractor'
        || auth.user.userType === 'superAdmin',
      quantity: currentWorkOrder.quantity,
      approvedHoursQty: currentWorkOrder.approvedHoursQty,
      approvedDeviceQty: currentWorkOrder.approvedDeviceQty,
      finalPayAdjustment: currentWorkOrder.finalPayAdjustment || '',
      adjustmentReason: currentWorkOrder.adjustmentReason || '',
      communication: this.controlBoolValue(currentWorkOrder.communicationAcceptable),
      work: this.controlBoolValue(currentWorkOrder.workAcceptable),
      deliverables: this.controlBoolValue(currentWorkOrder.deliverablesAcceptable),
      isApproveAdjustment: currentWorkOrder.isApproveAdjustment,
      selectedExpenses: expenses
        .filter(item => approvedExpenseIds.includes(item.value)),
      rejectedExpensesReasons,
      expenses,
      payMinimum: currentWorkOrder.payBaseRateAsMinimum,
    }, this.calculateFinalPay);
  }

  getPercentValueString = (percent = 0.00) => (`(${percent}%)`);

  calculateFinalPay = () => {
    const {
      approvedHoursQty,
      approvedDeviceQty,
      quantity,
      payMinimum,
    } = this.state;

    const { currentWorkOrder } = this.props;
    const basicQty = getQtyByPayType(
      currentWorkOrder.basicType,
      approvedHoursQty,
      approvedDeviceQty,
      quantity,
      payMinimum,
    );
    let approvedBasePotentialPay = currentWorkOrder.bidAmountBase * basicQty;
    this.setState({ approvedBasePotentialPay });
    if (parseFloat(currentWorkOrder.bidAmountVariable)) {
      const actualVariableQty = getQtyByPayType(
        currentWorkOrder.variableType,
        approvedHoursQty,
        approvedDeviceQty,
        Infinity,
      );
      if (actualVariableQty > parseFloat(currentWorkOrder.variablePayAfter)) {
        const diffOfBaseTotalHrs = Math.min(
          parseFloat(actualVariableQty) - parseFloat(currentWorkOrder.variablePayAfter),
          parseFloat(currentWorkOrder.maxQuantity) - parseFloat(currentWorkOrder.variablePayAfter),
        );
        const variablePay = diffOfBaseTotalHrs * currentWorkOrder.bidAmountVariable;
        approvedBasePotentialPay += variablePay;
      }
    }
    this.setState({ finalEstimateTotal: approvedBasePotentialPay });
  }

  getApprovedExpensesAmount = () => {
    const { selectedExpenses } = this.state;
    return selectedExpenses.reduce((acc, cur) => acc + cur.amount, 0);
  }

  getReasonForDenyingExpenses = reason => {
    const {
      rejectedExpensesReasons,
      newRejection,
    } = this.state;
    const { toggleSecondModalClose } = this.props;
    const newRejectionReasonObject = {
      ...rejectedExpensesReasons,
      [newRejection]: reason,
    };
    this.setState(cur => ({
      rejectedExpensesReasons: newRejectionReasonObject,
      newRejection: '',
      selectedExpenses: cur.nexSelectValue,
      nexSelectValue: [],
    }));
    toggleSecondModalClose('explanationInputModal', true);
  }

  handlerOnBlurFinalPayParameter = event => {
    if (!event.target.value) this.setState({ [event.target.name]: 0 }, this.calculateFinalPay);
  }

  handlerChanges = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handlerNumberChanges = event => {
    const parseFloatValue = parseFloat(event.target.value);
    const newValue = Number.isNaN(parseFloatValue) ? '' : parseFloatValue;
    this.setState({
      [event.target.name]: newValue,
    }, () => {
      if (typeof newValue === 'number') this.calculateFinalPay();
    });
  };

  handlerCheckedChanges = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  handlerMultiCheckedChanges = (name, value) => {
    const {
      disabled,
      ...stateFields
    } = this.state;
    const { toggleModal } = this.props;
    if (disabled) return;
    const isRejected = stateFields[name].length > value.length;
    if (isRejected) {
      const newRejection = stateFields[name]
        .filter(item => !value.filter(el => item.value === el.value).length);
      const rejectedExpenseDescription = newRejection.length > 1 ? 'All rejected expenses' : newRejection[0].label;
      this.setState({
        newRejection: rejectedExpenseDescription,
        nexSelectValue: value,
      });
      // eslint-disable-next-line consistent-return
      return toggleModal(true, 'explanationInputModal', true, 'expenses');
    }
    this.setState({ [name]: value });
  };



  submitApprovals = (event, sendAdjustmentToContractor = false, justSaveData = false) => {
    event.preventDefault();
    const {
      finalPayAdjustment,
      adjustmentReason,
      expenses,
      selectedExpenses,
      rejectedExpensesReasons,
      approvedHoursQty,
      approvedDeviceQty,
      communication,
      work,
      deliverables,
      finalEstimateTotal,
    } = this.state;
    const {
      currentWorkOrder,
      saveApproveData,
      approvedWorkOrder,
      toggleModal,
      profile,
    } = this.props;

    const finalPay = currentWorkOrder.status === 'approved'
      ? currentWorkOrder.finalPay
      : parseFloat(finalPayAdjustment || 0)
      + parseFloat(finalEstimateTotal)
      + this.getApprovedExpensesAmount()
    if (!currentWorkOrder.payOutsideOfApp && (!justSaveData && profile.balance.total_balance < finalPay)) {
      toggleModal(true, 'confirmModal', true, {
        onAccept: () => {
          setTimeout(() => {
            this.submitApprovals(event, false, true)
          }, 0)
        },
        header: "Your funds balance is not enough to approve and pay",
        buttonLabels: {
          reject: 'CANCEL',
          confirm: 'SAVE ONLY',
        }
      });
      return;
    }

    if (finalPayAdjustment < 0 && !adjustmentReason) {
      Notification('warning', {
        message: 'Type your reason of a negative adjustment amount first!',
      });
      return;
    }
    if (finalPay < 0) {
      Notification('error', {
        message: 'Work Order can\'t be approved with negative final pay!',
      });
      return;
    }
    if (currentWorkOrder.clientApprovalCodes?.length) {
      const requiredApprovals = currentWorkOrder.clientApprovalCodes.filter((item) => item.required);

      if (requiredApprovals.some(item => !item.approvalCode.trim())) {
        Notification('warning', {
          message: 'Must Fill Out Client Approval Code',
        });
        return
      }
    }


    const newRejectedExpensesReasons = [];
    expenses.forEach(item => {
      if (!selectedExpenses.filter(el => el.value === item.value).length) {
        newRejectedExpensesReasons.push({
          id: item.value,
          expense: item.label,
          reason: rejectedExpensesReasons[item.label] || rejectedExpensesReasons['All rejected expenses'],
        });
      }
    });
    const workOrderData = {
      work_order_id: currentWorkOrder._id,
      approvedHoursQty,
      approvedDeviceQty,
      finalPayAdjustment,
      adjustmentReason,
      communicationAcceptable: communication,
      workAcceptable: work,
      deliverablesAcceptable: deliverables,
      approvedExpenses: selectedExpenses.map(item => item.value),
      sendAdjustmentToContractor,
      rejectedExpensesReasons: newRejectedExpensesReasons,
      clientApprovalCodes: currentWorkOrder.clientApprovalCodes || []
    };

    // alert(justSaveData)
    // eslint-disable-next-line consistent-return
    if (justSaveData) return saveApproveData(workOrderData, finalPay);

    approvedWorkOrder(workOrderData, finalPay);
  }

  revertToAssigned = (e) => {
    // if (e && typeof e.preventDefault === 'function') e.preventDefault();
    // if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
    const { currentWorkOrder: order } = this.props
    const { _id } = order

    this.props.revertWorkOrderTo('assigned', _id)
  }

  approvePayAdjustment = event => {
    event.preventDefault();
    event.stopPropagation();
    // eslint-disable-next-line react/destructuring-assignment
    this.props.approvePayAdjustmentByContractor(this.props.currentWorkOrder._id);
  }

  // eslint-disable-next-line react/sort-comp
  formRef = createRef();

  render() {
    const {
      quantity,
      approvedHoursQty,
      approvedDeviceQty,
      finalEstimateTotal,
      finalPayAdjustment,
      adjustmentReason,
      communication,
      work,
      deliverables,
      disabled,
      selectedExpenses,
      expenses,
    } = this.state;
    const { currentWorkOrder, auth } = this.props;
    const workOrderControlByStatus = workOrderStatusControl(currentWorkOrder.status);

    
    const paySubtotal = currentWorkOrder.status === 'approved'
    ? currentWorkOrder.finalPay
    : (
      parseFloat(finalPayAdjustment || 0)
      + parseFloat(finalEstimateTotal)
      + this.getApprovedExpensesAmount()
    )
    const fivePercentFee = paySubtotal * 0.05;
    // onClick={event => this.submitApprovals(event, false, true)}
    return (
      <form ref={this.formRef} onSubmit={event => this.submitApprovals(event)}>
        <div className="text-in-one-line" style={{ textAlign: 'left' }}>
          <MDBRow>
            <hr className="my-4 hrline2" />
          </MDBRow>
          <MDBRow style={{ marginBottom: '15px' }}>
            <MDBCol><h3>Work Order Approval</h3></MDBCol>
          </MDBRow>

          <div className="line_blocks">
            <div className="block_label">
              Rate Performance
            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <label>{`Soft Skills - ${this.getPercentValueString(currentWorkOrder.percentCommunication)}`}</label>
              <label className="check_btn">
                <input
                  disabled={disabled}
                  type="checkbox"
                  id="communication"
                  name="communication"
                  onChange={this.handlerCheckedChanges}
                  checked={communication}
                />
                <div className="block_label">Acceptable</div>
              </label>
            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <label>{`Work - ${this.getPercentValueString(currentWorkOrder.percentWork)}`}</label>
              <label className="check_btn">
                <input
                  disabled={disabled}
                  type="checkbox"
                  id="work"
                  name="work"
                  onChange={this.handlerCheckedChanges}
                  checked={work}
                />
                <div className="block_label">Acceptable</div>
              </label>
            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <label>{`Deliverables - ${this.getPercentValueString(currentWorkOrder.percentDeliverables)}`}</label>
              <label className="check_btn">
                <input
                  disabled={disabled}
                  type="checkbox"
                  id="deliverables"
                  name="deliverables"
                  onChange={this.handlerCheckedChanges}
                  checked={deliverables}
                />
                <div className="block_label">Acceptable</div>
              </label>
            </div>
          </div>


          <div className="line_blocks">
            <div className="block_label">
              Base Pay
            </div>

            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>

              <label>{`Amount - ${currentWorkOrder.bidAmountBase.toLocaleString('en-US', localCurrencySettings)}`}</label>
              <label>{`Per - ${currentWorkOrder.basicType}`}</label>

            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>

              <label>{`Qty - ${quantity}`}</label>
              <label>
                {`Est.Pay - ${(
                  currentWorkOrder.bidAmountBase * (
                    currentWorkOrder.basicType === 'Site' ? 1 : currentWorkOrder.quantity
                  )
                ).toLocaleString('en-US', localCurrencySettings)}`}
              </label>
            </div>
          </div>

          <div className="line_blocks">
            <div className="block_label">
              Variable Pay
            </div>

            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
              <label className="font11">
                {
                  `Amount - ${(currentWorkOrder.bidAmountVariable || 0).toLocaleString('en-US', localCurrencySettings)
                  }`
                }
              </label>
              <label className="font11">{`Per - ${currentWorkOrder.variableType}`}</label>
            </div>

            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
              <label className="font11">{`After - ${currentWorkOrder.variablePayAfter}`}</label>
              <label className="font11">{`Max.Qty - ${currentWorkOrder.maxQuantity || 0}`}</label>

            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', alignItems: 'center' }}>
              <label className="font11">Actual Qty Hours</label>
              <input
                min={0.00}
                step="any"
                disabled={disabled}
                type="number"
                className="form-control woaaq"
                placeholder={0}
                name="approvedHoursQty"
                defaultValue={approvedHoursQty}
                onBlur={this.handlerOnBlurFinalPayParameter}
                onChange={this.handlerNumberChanges}
                style={{ width: '150px ' }}
              />
            </div>

            {isDeviceType(currentWorkOrder.basicType, currentWorkOrder.variableType, currentWorkOrder.variableAmount)
              && (
                <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <label className="font11 text-in-one-line">Actual Qty Devices</label>
                  <div className="flex-box">
                    <label
                      className="font11 font-weight-bolder"
                      style={{ color: '#ffff32', marginRight: '10px' }}
                    >
                      {`Contractor Qty: ${currentWorkOrder.qtyDevices || 0}`}
                    </label>
                    <input
                      style={{ width: '70px' }}
                      min={0.00}
                      step="any"
                      disabled={disabled}
                      type="number"
                      className="form-control woaaq"
                      placeholder={0}
                      name="approvedDeviceQty"
                      defaultValue={approvedDeviceQty}
                      onBlur={this.handlerOnBlurFinalPayParameter}
                      onChange={this.handlerNumberChanges}
                    />

                  </div>
                </div>
              )
            }
            {
              workOrderControlByStatus.completed && auth.user.userType !== 'contractor'
                && currentWorkOrder.basicType === 'Hour'
                && (
                  currentWorkOrder.approvedHoursQty > (
                    currentWorkOrder.quantity
                    + (
                      currentWorkOrder.variableType === 'Hour'
                        ? currentWorkOrder.maxQuantity - currentWorkOrder.variablePayAfter
                        : 0
                    )
                  )
                ) ? (
                <div className="field_block" style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px 0' }}>

                  <EstimatedTimeOverageLabel
                    text="Over Est. Time!"
                  />
                </div>
              )
                : <></>
            }

          </div>

          <div className="line_blocks">
            <div className="block_label">
              Final Pay
            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
              <label className="font11">Base Pay </label>
              <span>{(currentWorkOrder.bidAmountBase).toLocaleString('en-US', localCurrencySettings)}</span>

            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
              <label className="font11">Variable Pay </label>
              <label>{(currentWorkOrder.bidAmountVariable || 0).toLocaleString('en-US', localCurrencySettings)}</label>
            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
              <label className="font11">Estimated Total </label>

              <label>{finalEstimateTotal.toLocaleString('en-US', localCurrencySettings)}</label>
            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>

              <label className="font11">Pay Adjustments</label>
              <input
                disabled={disabled}
                type="number"
                className="form-control woaaq"
                placeholder={0}
                name="finalPayAdjustment"
                defaultValue={finalPayAdjustment}
                onBlur={this.handlerOnBlurFinalPayParameter}
                onChange={this.handlerNumberChanges}
                style={{ width: '150px ' }}
              />
            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
              <label className="font11">Pay Adjustment Reason</label>
            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <textarea
                disabled={disabled}
                type="text"
                className="form-control woaaq"
                placeholder="Type your reason"
                name="adjustmentReason"
                defaultValue={adjustmentReason}
              />
            </div>
          </div>

          {Boolean(expenses.length) && (
            <div className="line_blocks">
              {currentWorkOrder.status !== 'approved' &&
                <div className="block_label" style={{ color: 'green' }}>
                  Tech Added Expenses!
                </div>
              }
              <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
                <label className="font11">Expenses</label>
                <Select
                  components={
                    {
                      ValueContainer: CustomValueContainer,
                      MultiValueLabel: CustomMultiValueLabel,
                    }
                  }
                  placeholder="Expenses ..."
                  hideSelectedOptions={false}
                  isMulti
                  closeMenuOnSelect={false}
                  options={expenses}
                  value={selectedExpenses}
                  styles={customSelectStyle}
                  onChange={(value) => this.handlerMultiCheckedChanges('selectedExpenses', value || [])}
                />
              </div>
              {
                this.formRef?.current
                  ? (
                    <PortalContainer
                      parentContainer={this.formRef.current}
                      modalName="explanationInputModal"
                    >
                      <ExplanationInputModal
                        isCloseAvailable
                        returnExplanation={this.getReasonForDenyingExpenses}
                        title="Reason to deny expenses"
                        type="expenses"
                      />
                    </PortalContainer>
                  )
                  : <></>
              }
              <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>

                <label className="font11">Total Expenses : </label>
                <label className="font11">
                  {this.getApprovedExpensesAmount().toLocaleString('en-US', localCurrencySettings)}
                </label>
              </div>
            </div>
          )}

          <div className="line_blocks">
            
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
              <label className="block_label" style={{ fontStyle: 'italic', fontSize: '18px' }}>Pay Subtotal</label>
              <label className="block_label" style={{ color: 'green', fontSize: '18px' }}>
                {
                  paySubtotal.toLocaleString('en-US', localCurrencySettings)
                }
              </label>
            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
              <label className="block_label" style={{ fontStyle: 'italic', fontSize: '18px' }}>5% Fee</label>
              <label className="block_label" style={{ color: 'green', fontSize: '18px' }}>
                {
                  fivePercentFee.toLocaleString('en-US', localCurrencySettings)
                }
              </label>
            </div>
            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
              <label className="block_label" style={{ fontStyle: 'italic', fontSize: '18px' }}>Final Pay</label>
              <label className="block_label" style={{ color: 'green', fontSize: '18px' }}>
                {(paySubtotal - fivePercentFee).toLocaleString('en-US', localCurrencySettings)}
              </label>
            </div>
          </div>

          {currentWorkOrder.status === 'approved' && auth.user.userType === 'client' && Boolean(currentWorkOrder.clientApprovalCodes?.length) && (
            <div className="line_blocks">
              <div className="block_label">
                Client Approval Codes
              </div>
              {
                currentWorkOrder.clientApprovalCodes.map(approvalCode => (
                  <div
                    key={approvalCode._id || approvalCode.name}
                    className="field_block"
                    style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}
                  >
                    <div className='mt-2'>{approvalCode.name}</div>
                    <div className='d-flex mt-2'>
                      <input
                        step="any"
                        type="text"
                        className="form-control woaaq w-75"
                        placeholder="Approval Code Text"
                        // name="approvedHoursQty"
                        disabled
                        value={approvalCode.approvalCode || ''}
                      // onBlur={this.handlerOnBlurFinalPayParameter}
                      // onChange={(e) => { approvalCode.approvalCode = e.target.value }}
                      />
                      {approvalCode.required &&
                        <span className='requiredField'>*</span>
                      }
                    </div>

                  </div>
                ))
              }
            </div>
          )}


          {
            currentWorkOrder.status === 'completed'
            && (
              <>
                {
                  // eslint-disable-next-line no-nested-ternary
                  auth.user.userType === 'superAdmin'
                    ? (
                      <div className="line_blocks">
                        <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
                          <button
                            type="button"
                            className="standard_btn curry_btn"
                            onClick={event => this.revertToAssigned(event)}
                            style={{ marginLeft: '0' }}
                          >
                            Revert to Assigned
                          </button>
                        </div>
                      </div>
                    )
                    // eslint-disable-next-line no-nested-ternary
                    : auth.user.userType === 'client'
                    ? (
                      <>
                        <div className="line_blocks">
                          {!!currentWorkOrder.clientApprovalCodes?.length &&
                            <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
                              {currentWorkOrder.clientApprovalCodes.map(approvalCode => (
                                <React.Fragment key={approvalCode._id || approvalCode.name}>
                                  <div className='mt-2'>{approvalCode.name}</div>
                                  <div className='d-flex mt-2'>
                                    <input
                                      step="any"
                                      type="text"
                                      className="form-control woaaq"
                                      placeholder="Approval Code Text"
                                      name="clientApprovalCode"
                                      defaultValue={approvalCode.approvalCode || ''}
                                      // onBlur={this.handlerOnBlurFinalPayParameter}
                                      onChange={(e) => { approvalCode.approvalCode = e.target.value }}
                                      style={{ width: '150px' }}
                                    />
                                    {approvalCode.required &&
                                      <span className='requiredField'>*</span>
                                    }
                                  </div>
                                </React.Fragment>
                              ))}
                            </div>
                          }
                            {this.props.profile?.clientUser?.accessctrl !== 'Dispatcher' && (
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '10px',
                                backgroundColor: '#e8f4fd',
                                borderRadius: '6px',
                                padding: '12px 14px',
                                margin: '10px 0',
                              }}
                            >
                              <span
                                aria-hidden="true"
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: '18px',
                                  height: '18px',
                                  minWidth: '18px',
                                  borderRadius: '50%',
                                  backgroundColor: '#2196f3',
                                  color: '#fff',
                                  fontSize: '12px',
                                  fontWeight: 700,
                                  fontStyle: 'normal',
                                  marginTop: '2px',
                                  lineHeight: 1,
                                }}
                              >
                                i
                              </span>
                              <em style={{ fontWeight: 700, color: '#333', margin: 0, fontSize: '13px', lineHeight: 1.4 }}>
                                Please note, if the contractor&apos;s bank allows for real time payments it will process to paid same day. If their bank only accepts ACH, it could take up to 3 business days before the work order will move to paid status
                              </em>
                            </div>
                          )}
                          <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
                            {
                              (finalPayAdjustment < 0)
                              && (
                                <button
                                  style={{ marginLeft: '0' }}
                                  className="primary_btn primary_color "
                                  onClick={event => this.submitApprovals(event, true)}
                                >
                                  Send Adjustment to Contractor
                                </button>
                              )
                            }
                            <button
                              className="standard_btn green_btn"
                              onClick={event => this.submitApprovals(event, false, true)}
                            >
                              SAVE ONLY
                            </button>
                          </div>
                        
                          <div className="field_block" style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0' }}>
                            <button
                              type="button"
                              className="standard_btn curry_btn"
                              onClick={event => this.revertToAssigned(event)}
                              style={{ marginLeft: '0' }}
                            // This was copied from the save button and needs a new method to call
                            // the backend server to change the status.
                            >
                              Revert to Assigned
                            </button>

                            {this.props.profile?.clientUser?.accessctrl !== 'Dispatcher' &&

                              <button
                                disabled={
                                  finalPayAdjustment < 0
                                  && (
                                    !currentWorkOrder.isApproveAdjustment
                                    || (currentWorkOrder.finalPayAdjustment !== finalPayAdjustment)
                                  )
                                }
                                color={
                                  finalPayAdjustment < 0 && !currentWorkOrder.isApproveAdjustment
                                    ? 'grey'
                                    : 'info'
                                }
                                className="primary_btn primary_color"
                                type="submit"
                              >
                                Approve and Pay
                              </button>
                            }
                          </div>
                        </div>
                      </>
                    )
                    : finalPayAdjustment < 0 && auth.user.userType === 'contractor'
                      ? (

                        <button
                          color={currentWorkOrder.isApproveAdjustment ? 'green' : 'info'}
                          className="approveandpaybutton"
                          onClick={this.approvePayAdjustment}
                        >
                          {currentWorkOrder.isApproveAdjustment ? 'Approved' : 'Approve'}
                          {' Pay Adjustment'}
                        </button>
                      )
                      : <></>
                }

                <div className="block_label" style={{ color: 'green' }} title={rolloverInfoMessage[auth?.user?.userType]}>
                  Have issues with this work order?
                </div>
              </>
            )
          }
        </div>
      </form>
    );
  }
}

const mapDispatchToProps = {
  revertWorkOrderTo,
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ApproveWorkOrder);
